import React, { Component } from 'react'
import AuthenticationService from '../services/AuthenticationService';
import couterpart from 'counterpart';
import { withRouter } from 'react-router-dom'
import "../css/style.css";
import {IoIosAdd} from 'react-icons/io';
import { ICON_COLOR } from '../icon';

class ItemButtons extends Component {
    state = {
        action: null
    }

    handleChangeStatus(e){
        this.setState({action: 'ADD'});
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.action === 'ADD'){
            this.props.history.push("/items/add");
        }
    }

    renderForAdmin(){
        if (AuthenticationService.isAdmin() || AuthenticationService.isService()){
            const button_add = couterpart.translate('button_add');
            return(<>
            <button name="Add" className="myButton" 
            onClick={this.handleChangeStatus.bind(this)}>
            <IoIosAdd color={ICON_COLOR}/>&nbsp;{button_add}</button>
            </>
            );
        }
        return (<></>);
    }

    render() {
        return (
            <div>
                {this.renderForAdmin()}      
            </div>
        )
    }
}

export default withRouter(ItemButtons)
